import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { GrainFilters } from "./components/Grain/Grain";
import Nav from "./components/Nav/Nav";
import Hero from "./components/Hero/Hero";
// import MediaLogos from "./components/MediaLogos/MediaLogos";
import Agents from "./components/Agents/Agents";
import Numbers from "./components/Numbers/Numbers";
import Testimonials from "./components/Testimonials/Testimonials";
import Security from "./components/Security/Security";
import Pricing from "./components/Pricing/Pricing";
import Faq from "./components/Faq/Faq";
import Cta from "./components/Cta/Cta";
import Footer from "./components/Footer/Footer";
import WhatsAppButton from "./components/WhatsAppButton/WhatsAppButton";
import { PLANS } from "./data/plans";

// Links "/#secao" (do nav e do rodapé, inclusive vindos de /terms) navegam pelo router,
// que não rola até a âncora sozinho. `key` muda a cada clique, mesmo repetindo o hash.
const useScrollToHash = () => {
  const { hash, key } = useLocation();

  useEffect(() => {
    if (!hash) return;
    document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" });
  }, [hash, key]);
};

function App() {
  useScrollToHash();

  return (
    <>
      <a className="skip" href="#agents">
        Pular para o conteúdo
      </a>
      <GrainFilters />
      <Nav />
      <main>
        <Hero />
        {/* <MediaLogos /> */}
        <Agents />
        <Numbers />
        <Testimonials />
        <Security />
        <Pricing plans={PLANS} />
        <Faq />
        <Cta />
      </main>
      <Footer />
      <WhatsAppButton />
    </>
  );
}

export default App;
